import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TODO_NOTIFICATION_TYPES } from 'NotificationsApp/ts/features/notifications-side-menu/constants';
import { Notification } from 'NotificationsApp/ts/interfaces/notifications.interface';

import { NotificationsService } from 'NotificationsApp/ts/services/notifications.service';

@Component({
    standalone: false,
    selector: 'tr[ycn-notifications-menu-list-item]',
    templateUrl: './notifications-menu-list-item.template.html',
})
export class NotificationsMenuListItemComponent implements OnInit {
    @Input() notification!: Notification;

    @Output() removeNotification = new EventEmitter<Notification>();

    @Output() notificationRead = new EventEmitter<Notification>();

    errorMessage?: string;

    expandable: boolean = false;

    expanded: boolean = false;

    bulletColor: string = 'bullet-green';

    constructor(private notificationsService: NotificationsService) {}

    ngOnInit(): void {
        this.expandable = !!this.notification.message && this.notification.message.length > 30;
        this.bulletColor = this.getBulletColor();
    }

    deleteNotification(): void {
        this.notificationsService.deleteNotification(this.notification).subscribe({
            next: () => {
                this.removeNotification.emit(this.notification);
            },
            error: (rsp) => {
                this.errorMessage = rsp.error;
            },
        });
    }

    getBulletColor(): string {
        if (this.notification.read) {
            return 'bullet-gray-70';
        }

        if (TODO_NOTIFICATION_TYPES.has(this.notification.type)) {
            return 'bullet-orange';
        }
        return 'bullet-green';
    }

    markNotificationRead(): void {
        if (!this.notification.read) {
            this.notificationsService.markNotificationAsRead(this.notification).subscribe({
                next: () => {
                    this.notification.read = true;
                    this.bulletColor = this.getBulletColor();
                    this.notificationRead.emit(this.notification);
                },
                error: (rsp) => {
                    this.errorMessage = rsp.error;
                },
            });
        }
    }

    toggleExpanded(): void {
        this.expanded = !this.expanded;
    }
}
